import React, { useState , useEffect } from "react";
import axios from "axios";

function useFetch() {
  const [data, setData] = useState([]);
  const [isLoading , setLoding] = useState(false)

  const query = ` {
    user(username: "Abdelmalek") {
      username,
      photo,
      publication {
        posts (page : 0){
          slug
          title
          brief
          coverImage
        }
      }
  }
  }
`;


  useEffect(() => {
    const fetchData = async () => {
      setLoding(true);
      const req = await axios({
        url : "https://api.hashnode.com/",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          query,
        },
      });
  
      const resData = req.data.data.user;
      setData(resData);
      setLoding(false);
    };
  
    fetchData();
  } , [])

 

  return [data , isLoading];
}

export default useFetch;
